import * as React from 'react';

// named imports for React.lazy: https://github.com/facebook/react/issues/14603#issuecomment-726551598
export function lazyImport<
  T extends React.ComponentType,
  TI extends { [K2 in TK]: T },
  TK extends keyof TI
>(factory: () => Promise<TI>, name: TK): TI {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return Object.create({
    [name]: React.lazy(async () => factory().then((module) => ({ default: module[name] }))),
  });
}

// Usage
// const { Home } = lazyImport(() => import("./Home"), "Home");
